<template>
  <section class="print-students">
    <v-row row justify-center wrap class="mb-2">
      <v-col cols="12">
        <h2 style="line-height: 48px;">Download Student List</h2>
      </v-col>
      <v-col md="12">
        <p>
          Download an Excel file of all your students so you can input and track
          their names against the student codes.
          <br /><br />
          For privacy reasons, all student data is totally anonymous. We
          recommend recording the student’s name against the Student Code when
          you assign it to them. You can also use the Print Student Cards tab to
          get downloadable cards to distribute to your students with their
          unique student code.
        </p>
      </v-col>
      <v-col cols="12">
        <v-card flat>
          <v-card-actions>
            <v-btn @click="downloadList" color="primary" class="mr-3">
              <v-icon left dark>file_download</v-icon>
              {{ selected.length ? 'Download Selected' : 'Download File' }}
            </v-btn>
            <v-select
              v-model="filter"
              :items="filterOptions"
              label="Filter"
              class="print-filter"
            ></v-select>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              class="pb-3"
            ></v-text-field>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="classInvitations"
          :search="search"
          select-show
          item-key="id"
          hide-default-footer
          :loading="loading"
          :options.sync="pagination"
          show-select
          flat
          @page-count="pageCount = $event"
        >
          <template v-slot:no-data>
            <p class="mb-0 text-center">
              Loading, please wait
            </p>
          </template>
          <template v-slot:no-results>
            <p class="mb-0 text-center">
              No students in selection
            </p>
          </template>
          <template v-slot:body="{ items, isSelected, select }">
            <tbody>
              <tr
                v-for="item in items"
                :key="item.id"
                :active="isSelected(item)"
                @click.stop="select(item, !isSelected(item))"
              >
                <td>
                  <v-checkbox
                    color="primary"
                    :input-value="isSelected(item)"
                    primary
                    hide-details
                    class="pa-0 ma-0"
                    @click.stop="select(item, !isSelected(item))"
                  ></v-checkbox>
                </td>
                <td class="text-center">
                  {{ item.invitation_code }}
                </td>
                <td class="text-center">
                  {{ item.accepted_at || 'Not accepted' }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <div v-show="pageCount > 1" class="text-center pt-2">
          <v-pagination
            v-model="pagination.page"
            :length="pageCount"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { focus } from 'vue-focus'
import { mapGetters } from 'vuex'
import ClassInvitation from '@/modules/class/models/ClassInvitation'

export default {
  name: 'DownloadStudents',
  directives: { focus: focus },
  data() {
    return {
      pageCount: 0,
      pagination: {
        itemsPerPage: 10,
        sortBy: ['invitation_code'],
        sortDesc: [true]
      },
      filter: 'not-accepted',
      filterOptions: [
        { text: '- All -', value: 'all' },
        { text: 'Students who accepted invites', value: 'accepted' },
        { text: "Students who haven't accepted invites", value: 'not-accepted' }
      ],
      headers: [
        { text: 'Student Code', value: 'invitation_code', align: 'center' },
        { text: 'Invitation accepted', value: 'accepted_at', align: 'center' }
      ],
      selected: [],
      search: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters('entities/classes', ['currentClassId']),
    classInvitations() {
      let q = ClassInvitation.query().where(
        'custom_class_id',
        this.currentClassId
      )

      if (this.filter === 'accepted') {
        q.where(record => record.accepted_at !== null)
      } else if (this.filter === 'not-accepted') {
        q.where('accepted_at', null)
      }

      return q.get()
    }
  },
  async mounted() {
    this.loading = true
    await ClassInvitation.dispatch('getClassInvitations', {
      classId: this.currentClassId
    })
    this.loading = false
  },
  methods: {
    async downloadList() {
      let base_url = process.env.VUE_APP_API_URL
      if (process.env.NODE_ENV === 'production') {
        base_url = window.location.origin
      }

      let ids = ''
      if (this.selected) {
        this.selected.map(classInvitation => {
          ids += '&ids[]=' + classInvitation.id
        })
      }

      window.open(
        base_url +
          '/api/teachers/custom-classes/' +
          this.currentClassId +
          '/downloads/?filter=' +
          this.filter +
          '&search=' +
          this.search +
          ids,
        '_blank'
      )
    }
  }
}
</script>
